import React from "react";

function renderSubtitle(subtitle) {
  if (!subtitle) {
    return null;
  }

  return <div className="subtitle">{subtitle}</div>;
}

function renderActions(actions) {
  if (!actions) {
    return null;
  }

  return <div className="page-header__actions">{actions}</div>;
}

function renderTitle(title, icon) {
  if (!icon) {
    return <h1>{title}</h1>;
  }

  return (
    <div className="page-header__title">
      {icon}
      <h1>{title}</h1>
    </div>
  );
}

export default function PageHeader({ title, subtitle, actions, icon }) {
  return (
    <header className="page-header">
      <div>
        {renderTitle(title, icon)}
        {renderSubtitle(subtitle)}
      </div>
      {renderActions(actions)}
    </header>
  );
}
